// Index file for the directory. Don't add anything else here.
import CarouselSneakertimeTransaction from './CarouselSneakertimeTransaction';
export default CarouselSneakertimeTransaction;
